import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { BookActivity } from "@modules/bookActivities/types";
import { ListBookActivitiesQueryFilters } from "./types";

export async function getBookActivitiesService(filters?: ListBookActivitiesQueryFilters): Promise<BookActivity[]> {
  try {
    const { data } = await api.get<ApiResponse<BookActivity>>(`v1/book_activity_admin/`, {
      params: {
        page: filters?.page,
        page_size: filters?.perPage,
        ordering: "-id",
        search: filters?.search,
        ids: Array.isArray(filters?.ids) ? filters.ids.join(",") : undefined,
      },
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching book categories:", error);
    throw error;
  }
}
